import React from 'react';
import PropTypes from 'prop-types';
import BasicToolTip from "./BasicToolTip";
import ConstrainedToolTip from "./ConstrainedToolTip";
// This renders a component with the `data-tip` attribute.
// If you're using this component, make sure that there is
// a <ReactTooltip /> component mounted somewhere.
var ToolTip = function ToolTip(props) {
  return props.constrainWidth ? /*#__PURE__*/React.createElement(ConstrainedToolTip, props) : /*#__PURE__*/React.createElement(BasicToolTip, props);
};
ToolTip.propTypes = {
  text: PropTypes.string,
  name: PropTypes.string,
  constrainWidth: PropTypes.bool
};
ToolTip.defaultProps = {
  text: '',
  name: 'info-circle',
  constrainWidth: false
};
export default ToolTip;